import BaseForm from '../../../template/BaseForm';
import React, { Component } from 'react';
import Form, { SimpleItem, GroupItem, TabbedItem, Tab } from 'devextreme-react/form';
import DataGrid from 'devextreme-react/data-grid';
import API, { userDataSource } from '../../../services/AplicationService';
import { showSuccessMessage, showConfirmationMessage, showWarnMessage, handleError } from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import DefaultGrid from '../../../components/DefaultGrid';

const masterProps = {
	title: 'Acesso dos Usuários',
	subtitle: 'Consulte o acessos dos usuários',
};
const initialState = {
	userId: null,
	startDate: null,
	endDate: null,
};
export default class UserAccess extends Component {
	state = { ...initialState };
	constructor(props) {
		super(props);
		this.dataGrid = React.createRef();
		this.baseForm = React.createRef();
		this.loadUsersAccess = this.loadUsersAccess.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
	}
	loadUsersAccess(page, pageSize) {
	
		let userId = this.state.userId;
		let startDate = this.state.startDate;
		let endDate = this.state.endDate;
		return API.get('/account/findUserAccess', {
			params: {
				page: page,
				pageSize: pageSize,
				userId: userId,

				startDate: startDate,
				endDate: endDate,
			},
		})
			.then(response => {
				let result = {
					data: response.data.userAccess,
					totalCount: response.data.totalRegisters,
				};
				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}	
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	renderFilter() {
		return (
			<Form
				formData={this.state}
				colCount={1}
				alignItemLabels={true}
				alignItemLabelsInAllGroups={true}
				showColonAfterLabel={false}
				labelLocation={'left'}
			>
				<GroupItem colCount={5}>
					<SimpleItem
						colSpan={2}
						dataField={'userId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						editorOptions={{
							dataSource: userDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'name',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Usuário' }}
					/>
					<SimpleItem
						colSpan={1}
						dataField={'startDate'}
						editorType={'dxDateBox'}
						editorOptions={{
							type: 'date',
							displayFormat: 'dd/MM/yyyy',
						}}
						label={{ text: 'Data Inicial' }}
					/>
					<SimpleItem
						colSpan={1}
						dataField={'endDate'}
						editorType={'dxDateBox'}
						editorOptions={{
							type: 'date',
							displayFormat: 'dd/MM/yyyy',
						}}
						label={{ text: 'Data Final' }}
					/>

					<SimpleItem>
						<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
							<i className="fa fa-search" />
							&nbsp; Buscar
						</button>
					</SimpleItem>
				</GroupItem>
			</Form>
		);
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncListData={this.loadUsersAccess}
					defaultColumns={[
						{ dataField: 'id', caption: 'Nº', width: '5%' },
						{ dataField: 'userName', caption: 'Usuário' },
						{ dataField: 'email', caption: 'E-mail' },
						{ dataField: 'administrativeCompanyName', caption: 'Empresa' },
						{
							dataField: 'onCreated',
							dataType: 'date',
							format: 'dd/MM/yyyy HH:mm',
							caption: 'Acessou em',
							width: '15%',
						},
						{
							dataField: 'expiredOn',
							dataType: 'date',
							format: 'dd/MM/yyyy HH:mm',
							caption: 'Expira em',
							width: '15%',
						},
					]}
				/>
			</React.Fragment>
		);
	}

	render(props) {
		return (
			<BaseForm {...masterProps} ref={this.baseForm}>
				<div className="box box-default padding-10">
					<div className="box-body">
						<div className="row">
							<div className="col-md-12"> {this.renderFilter()}</div>
						</div>
					</div>
					<div className="box-body">
						<div className="row">{this.renderGrid()}</div>
					</div>
				</div>
			</BaseForm>
		);
	}
}
